import FileSaver from 'file-saver';
import { BaseButton, Button,  DefaultButton, Dialog, DialogFooter, DialogType, Dropdown,  Icon, IconButton, IDropdownOption, Label,  PrimaryButton, TooltipHost } from 'office-ui-fabric-react';
import React, { Fragment, useCallback, useContext,  useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { WsSalesSolutionDeliverableClass } from '../../../core-sales';
import { getChildItemsFromTopLevelItems } from '../../../helpers/item-helpers';
import { getFromState } from '../../../helpers/solution';
import { findActionById } from '../../../core/sales-actions';
import { Loading } from '../../Shared';
import { WsSalesSolutionContext } from '../SalesSolutionContext';
import { getDocumentDownload } from "./SolutionComponents";
import { WsPanelContext } from "../SalesContainerWithPanel";



const deliverableReviewOptions = [
  { key: 1,  text: '1' },
  { key: 2,  text: '2' },
  { key: 3,  text: '3' },
  { key: 4,  text: '4' },
  { key: 5,  text: '5' },
  { key: 6,  text: '6' },
  { key: 7,  text: '7' },
  { key: 8,  text: '8' },
  { key: 9,  text: '9' },
  { key: 10, text: '10' },
];




const WsSalesDeliverableReviewSettings = (
  props: {
    label: string,
    settingKey: string,
    settingValue: number,
    createOrSave?: boolean,
    setValue?: (key: string, value: number) => void
  }) => {

  const solutionContext = useContext(WsSalesSolutionContext);

  return (
    <>
      <Dropdown
        label={props.label}
        options={deliverableReviewOptions}
        onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {

          if (option) {

            const newSettingValue = Number(option.key);

            if (props.createOrSave) {

              const newDeliverableReview = getFromState(solutionContext.salesProcess?.state, 'deliverableReviewSettings');

              newDeliverableReview[props.settingKey] = newSettingValue;

              const newSalesProcess = { ...solutionContext.salesProcess };

              newSalesProcess.state['deliverableReviewSettings'] = newDeliverableReview;

              solutionContext.setSalesProcess(newSalesProcess);

              setTimeout(async () => {
                // TODO: refactor createOrSave to not use state
                await solutionContext.createOrSave(solutionContext.currentStep, { showSuccess: true });
              }, 800);

            }


            if (props.setValue) {
              props.setValue(props.settingKey, newSettingValue);
            }

          }
        }}
        placeholder="Select value"
        selectedKey={props.settingValue}
      />
    </>
  );
};


type WsSalesDeliverableReviewSettingsDialogProps = {
  editReviewSettingsItem: WsSalesSolutionDeliverableClass;
  setEditReviewSettingsItem: React.Dispatch<React.SetStateAction<WsSalesSolutionDeliverableClass | undefined>>;
};

const WsSalesDeliverableReviewSettingsDialog = (props: WsSalesDeliverableReviewSettingsDialogProps) => {

  const solutionContext = useContext(WsSalesSolutionContext);

  // const [ deliverableItem, setDeliverableItem ] = useState<any>(findItemById(solutionContext.items, props.dialogVisible, '', {}));

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.setEditReviewSettingsItem(undefined);
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.setEditReviewSettingsItem(undefined);
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.setEditReviewSettingsItem(undefined);

    const items = [ ...solutionContext.items ];

    props.editReviewSettingsItem.reviewSettings = deliverableReviewSettings;

    solutionContext.setItems(items);

    setTimeout(() => {
      // TODO: refactor createOrSave to not use state
      solutionContext.createOrSave(solutionContext.currentStep, { showSuccess: true });
    }, 800);
  };


  const [ deliverableReviewSettings, setDeliverableReviewSettings ] = useState<any>(props.editReviewSettingsItem.reviewSettings ? props.editReviewSettingsItem.reviewSettings : getFromState(solutionContext.salesProcess?.state, 'deliverableReviewSettings'));

  const setValue = useCallback((key: string, value: number) => {
    const nextDeliverableReviewSettings = { ...deliverableReviewSettings };
    nextDeliverableReviewSettings[key] = value;
    setDeliverableReviewSettings(nextDeliverableReviewSettings);
  }, [ deliverableReviewSettings ]);



  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        title: `${props.editReviewSettingsItem.name}`,
        type: DialogType.normal
      }}
      modalProps={{
        className: 'ws-sales-deliverable-review-settings-dialog',
        isBlocking: false,
        styles: {
          // main: { width: 700 }
        }
      }}
    >
      <Fragment>
        <div className="ws-sales-deliverable-review-settings-form" style={{ width: '550px' }}>

          <div className="columns">
            <div className="column">

              <div className="columns" style={{ marginBottom: 0 }}>
                <div className="column" style={{ paddingBottom: 0 }}>
                  <WsSalesDeliverableReviewSettings
                    label="Days for Review"
                    settingKey="review"
                    settingValue={deliverableReviewSettings.review}
                    setValue={setValue}
                  />
                </div>
                <div className="column">
                  <WsSalesDeliverableReviewSettings
                    label="Days for Update"
                    settingKey="update"
                    settingValue={deliverableReviewSettings.update}
                    setValue={setValue}
                  />
                </div>
                <div className="column">
                  <WsSalesDeliverableReviewSettings
                    label="Days for Client Approval"
                    settingKey="approve"
                    settingValue={deliverableReviewSettings.approve}
                    setValue={setValue}
                  />
                </div>
              </div>

              <div className="columns">
                <div className="column" style={{ paddingTop: 0 }}>
                  <WsSalesDeliverableReviewSettings
                    label="Review Cycles"
                    settingKey="cycles"
                    settingValue={deliverableReviewSettings.cycles}
                    setValue={setValue}
                  />
                </div>
                <div className="column"></div>
                <div className="column"></div>
              </div>

            </div>
          </div>

        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} />
        </>
      </DialogFooter>
    </Dialog>
  );
};


const WsSalesSolutionDescription = (props: { itemId: string, itemDescription: string }) => {

  return (
    <TooltipHost
      content={props.itemDescription}
      id={`ws-sales-solution-offering-tooltip-${props.itemId}`}
      // directionalHint={DirectionalHint.bottomCenter}
      calloutProps={{
        // className: 'ws-sales-solution-step-tooltip-callout',
        style: {
          width: '200px'
        }
      }}
    >
      <BiInfoCircle
        aria-describedby={`ws-sales-solution-offering-tooltip-${props.itemId}`}
        style={{
          fontSize: '16px',
          verticalAlign: 'middle',
          marginLeft: '5px',
          marginTop: '-3px'
        }}
      />
    </TooltipHost>
  );
};


type WsSalesSolutionDeliverablesAndWorkProductsListProps = {
  title: string;
  avanade: boolean;
  decode?: boolean;
};

const WsSalesSolutionDeliverablesAndWorkProductsList = (props: WsSalesSolutionDeliverablesAndWorkProductsListProps) => {

  const panelContext = useContext(WsPanelContext);
  const solutionContext = useContext(WsSalesSolutionContext);
  const deliverableReviewSettings = getFromState(solutionContext.salesProcess?.state, 'deliverableReviewSettings');
  const [ editReviewSettingsItem, setEditReviewSettingsItem ] = useState<WsSalesSolutionDeliverableClass | undefined>(undefined);

  let list: any[] = []; // TODO: remove any[] and undefined

  if (props.title === 'Deliverables') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'deliverables', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

  } else if (props.title === 'Work Products') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'workProducts', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });
  }



  const itemList = list.map((listItemAndActionItem) => {

    const listItem   = listItemAndActionItem[0];
    const actionItem = listItemAndActionItem[1];
    const findAction = findActionById(solutionContext.items, undefined, actionItem.id, '', { filterSelected: false, includeChildActions: true });
    const originPath = findAction?.path.replace(`/${actionItem.name}`, '').slice(1).replace(/\//g, ' / ') || '';

    return (
      <tr key={`ws-sales-item-list-${listItem.id}`}>
        <td style={{ fontSize: '12px', width: '240px' }}>{listItem.name}</td>

        <td style={{ fontSize: '12px' }}>
          {
          listItem.description
          &&
          <>
            <TooltipHost
              content={listItem.description}
              id={`ws-item-description-tooltip-${listItem.id}`}
              className="ws-item-description-tooltip"
              calloutProps={{
                className: 'ws-item-description-tooltip-callout'
              }}
            >
              <BiInfoCircle
                aria-describedby={`ws-item-description-tooltip-${listItem.id}`}
                style={{
                  fontSize: '16px',
                  verticalAlign: 'middle',
                  marginRight: '2px',
                  marginTop: '-2px'
                }}
              />
            </TooltipHost>
          </>
          }
        </td>

        <td style={{ fontSize: '14px' }}>
          {
            props.avanade
            ?
            <>
              {
                listItem.documentId
                ?
                <>
                  <a
                    onClick={async (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                      event.preventDefault(); // TODO: is this required?

                      const documentDownloadResult = await getDocumentDownload(listItem.documentId);

                      if (documentDownloadResult && documentDownloadResult.sasUrl) {
                        FileSaver.saveAs(documentDownloadResult.sasUrl, documentDownloadResult.documentFileName);
                      } else {
                        alert('Document does not exist in storage!'); // TODO: use dialog
                      }
                    }}
                  ><Icon iconName='Download' style={{
                    verticalAlign: 'top',
                    marginTop: '-2px'
                  }}
                  /></a>
                </>
                :
                null
              }
            </>
            :
            null
          }
        </td>

        <td style={{ fontSize: '12px' }}>{listItem.format.name}</td>

        {
          props.title === 'Deliverables'
          &&
          <td style={{ width: '150px', fontSize: '12px' }}>
            <IconButton
              iconProps={{ iconName: 'Edit' }}
              style={{
                marginTop: '-6px',
                verticalAlign: 'top'
              }}
              title="Change"
              ariaLabel="Change"
              onClick={() => {
                setEditReviewSettingsItem(listItem);
              }}
            />
            {
              listItem.reviewSettings
              ?
              <>{listItem.reviewSettings.review}-{listItem.reviewSettings.update}-{listItem.reviewSettings.approve} ({listItem.reviewSettings.cycles})</>
              :
              <>{deliverableReviewSettings.review}-{deliverableReviewSettings.update}-{deliverableReviewSettings.approve} ({deliverableReviewSettings.cycles})</>
            }
          </td>
        }

        <td style={{ fontSize: '12px', width: '260px' }}>
          <a onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            e.preventDefault();
            panelContext.setShowAction(actionItem);
          }}>{actionItem.name}</a>
        </td>

        <td style={{ fontSize: '12px' }}>{originPath}</td>
      </tr>
    );
  });



  if ((props.title === 'Deliverables') || props.title === 'Work Products') {

    return (
      <div>
        {
          !props.decode
          &&
          props.title === 'Deliverables'
          &&
          <div>
            <hr style={{ marginTop: 0, marginBottom: '10px' }} />
            <Label>Deliverable Review Settings</Label>
            <div className="columns" style={{ width: '550px', marginBottom: 0 }}>
              <div className="column" style={{ paddingBottom: 0 }}>
                <WsSalesDeliverableReviewSettings
                  label="Days for Review"
                  settingKey="review"
                  settingValue={deliverableReviewSettings.review}
                  createOrSave={true}
                />
              </div>
              <div className="column">
                <WsSalesDeliverableReviewSettings
                  label="Days for Update"
                  settingKey="update"
                  settingValue={deliverableReviewSettings.update}
                  createOrSave={true}
                />
              </div>
              <div className="column">
                <WsSalesDeliverableReviewSettings
                  label="Days for Client Approval"
                  settingKey="approve"
                  settingValue={deliverableReviewSettings.approve}
                  createOrSave={true}
                />
              </div>
            </div>
            <div className="columns" style={{ width: '550px' }}>
              <div className="column" style={{ paddingTop: 0 }}>
                <WsSalesDeliverableReviewSettings
                  label="Review Cycles"
                  settingKey="cycles"
                  settingValue={deliverableReviewSettings.cycles}
                  createOrSave={true}
                />
              </div>
              <div className="column"></div>
              <div className="column"></div>
            </div>
            <hr style={{ marginTop: '10px', marginBottom: '10px' }} />
          </div>
        }

        <table className="ws-sales-deliverables-work-products-list table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th style={{ paddingLeft: '8px' }}>Name</th>
              <th></th>
              <th></th>
              <th style={{ paddingLeft: '8px' }}>Format</th>
              {
                props.title === 'Deliverables'
                &&
                <th style={{ paddingLeft: '17px' }}>Review</th>
              }
              <th style={{ paddingLeft: '8px' }}>Action</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {itemList}
          </tbody>
        </table>
        {
          editReviewSettingsItem
          &&
          <WsSalesDeliverableReviewSettingsDialog
            editReviewSettingsItem={editReviewSettingsItem}
            setEditReviewSettingsItem={setEditReviewSettingsItem}
          />
        }
      </div>
    );

  } else {

    return (
      <>
        <Loading />
        <br/>
        <br/>
      </>
    );
  }
};




type WsSalesSolutionReviewListProps = {
  title: string;
  avanade: boolean;
};

const WsSalesSolutionReviewList = (props: WsSalesSolutionReviewListProps) => {

  const panelContext = useContext(WsPanelContext);
  const solutionContext = useContext(WsSalesSolutionContext);

  let list: any[] = []; // TODO: remove any[] and undefined

  if (props.title === 'Assumptions') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'assumptions', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

  } else if (props.title === 'Dependencies') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'dependencies', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

  } else if (props.title === 'Metrics') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'metrics', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

  } else if (props.title === 'Risks') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'risks', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });

  } else if (props.title === 'Tools') {
    list = getChildItemsFromTopLevelItems(solutionContext.items, 'tools', { includeChildCapabilities: true, includeChildActions: true, filterSelectedCapabilities: true, filterSelectedActions: true });
  }



  const itemList = list.map((listItemAndActionItem) => {

    const listItem   = listItemAndActionItem[0];
    const actionItem = listItemAndActionItem[1];
    const findAction = findActionById(solutionContext.items, undefined, actionItem.id, '', { filterSelected: false, includeChildActions: true });
    const originPath = findAction?.path.replace(`/${actionItem.name}`, '').slice(1).replace(/\//g, ' / ');

    return (
      <tr key={`ws-sales-item-list-${listItem.id}`}>
        

        <td style={{ fontSize: '12px', width: '260px' }}>
          {listItem.name}
          {
            props.title === 'Metrics'
            &&
            <> ({listItem.value})</>
          }
        </td>

        <td style={{ fontSize: '12px', width: '260px' }}>
          <a onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            e.preventDefault();
            panelContext.setShowAction(actionItem);
          }}>{actionItem.name}</a>
        </td>

        <td style={{ fontSize: '12px' }}>{originPath}</td>
      </tr>
    );
  });



  if (props.title === 'Assumptions' || props.title === 'Dependencies' || props.title === 'Metrics' || props.title === 'Risks' || props.title === 'Tools') {

    if (itemList.length > 0) {
      return (
        <div>
          <table className="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                {/* {
                  props.title === 'Metrics'
                  &&
                  <th style={{ paddingLeft: '8px' }}></th>
                } */}
                <th style={{ paddingLeft: '8px' }}>Name</th>
                
                <th style={{ paddingLeft: '8px' }}>Action</th>
                <th style={{ paddingLeft: '8px' }}></th>
              </tr>
            </thead>
            <tbody>
              {itemList}
            </tbody>
          </table>
        </div>
      );

    } else {
      return (
        <div>None</div>
      );
    }

  } else {

    return (
      <>
        <Loading />
      </>
    );
  }
};




export {
  WsSalesSolutionDescription,
  WsSalesSolutionDeliverablesAndWorkProductsList,
  WsSalesSolutionReviewList
};
